/**
 * Schema Zod del formulario de contacto — GUIA_REACT_v2 §6.4.
 *
 * Alineado 1:1 con `database.rules.json` (longitudes, regex, enum prácticas).
 * Los mensajes de error viven aquí, no en el JSX del componente.
 */
import { z } from 'zod';

import { PRACTICES } from '../../types/domain';
import { EMAIL_REGEX, PHONE_REGEX } from '../../utils/validators';

export const contactSchema = z.object({
  nombre: z
    .string()
    .trim()
    .min(2, 'Ingresa tu nombre (mínimo 2 caracteres).')
    .max(120, 'El nombre no debe superar 120 caracteres.'),

  empresa: z
    .string()
    .trim()
    .min(2, 'Ingresa el nombre de tu empresa.')
    .max(150, 'La empresa no debe superar 150 caracteres.'),

  email: z
    .string()
    .trim()
    .min(1, 'Ingresa tu correo corporativo.')
    .max(254, 'El correo es demasiado largo.')
    .regex(EMAIL_REGEX, 'Formato de correo no válido.'),

  telefono: z
    .string()
    .trim()
    .refine((v) => v === '' || PHONE_REGEX.test(v), {
      message: 'El teléfono debe tener exactamente 10 dígitos.',
    }),

  practica: z.enum(PRACTICES, { message: 'Selecciona una práctica de interés.' }),

  mensaje: z
    .string()
    .trim()
    .min(10, 'Cuéntanos tu reto en al menos 10 caracteres.')
    .max(2000, 'El mensaje no debe superar 2000 caracteres.'),

  acepto: z.literal(true, { message: 'Debes aceptar el Aviso de Privacidad.' }),
});

export type ContactSchema = z.infer<typeof contactSchema>;
